import React from 'react';
import { FileTextIcon, AlertTriangleIcon, TrendingUpIcon, AlertCircleIcon } from 'lucide-react';
interface KPISummaryProps {
  selectedLO: string;
}
const allKpiData: Record<string, {
  activeLoans: number;
  atRisk: number;
  pullThrough: string;
  dirtyFiles: number;
}> = {
  all: {
    activeLoans: 1250,
    atRisk: 47,
    pullThrough: '62%',
    dirtyFiles: 35
  },
  'Sarah Chen': {
    activeLoans: 180,
    atRisk: 8,
    pullThrough: '58%',
    dirtyFiles: 3
  },
  'Michael Davis': {
    activeLoans: 210,
    atRisk: 12,
    pullThrough: '55%',
    dirtyFiles: 5
  },
  'Chrao Dunon': {
    activeLoans: 165,
    atRisk: 6,
    pullThrough: '68%',
    dirtyFiles: 2
  },
  'Alex Kim': {
    activeLoans: 195,
    atRisk: 9,
    pullThrough: '60%',
    dirtyFiles: 12
  },
  'Priya Patel': {
    activeLoans: 220,
    atRisk: 7,
    pullThrough: '65%',
    dirtyFiles: 9
  },
  'Jann Fmt': {
    activeLoans: 140,
    atRisk: 3,
    pullThrough: '72%',
    dirtyFiles: 4
  },
  'Roda Kim': {
    activeLoans: 140,
    atRisk: 2,
    pullThrough: '70%',
    dirtyFiles: 3
  }
};
export function KPISummary({
  selectedLO
}: KPISummaryProps) {
  const data = allKpiData[selectedLO] || allKpiData['all'];
  const kpis = [{
    label: 'Total Active Loans',
    value: data.activeLoans.toLocaleString(),
    icon: FileTextIcon,
    iconColor: 'text-blue-600',
    bgColor: 'bg-blue-50'
  }, {
    label: 'At-Risk Count',
    value: data.atRisk.toString(),
    icon: AlertTriangleIcon,
    iconColor: 'text-red-600',
    bgColor: 'bg-red-50',
    trend: selectedLO === 'all' ? '+12% vs last week' : undefined
  }, {
    label: 'Avg Pull-Through Rate',
    value: data.pullThrough,
    icon: TrendingUpIcon,
    iconColor: 'text-green-600',
    bgColor: 'bg-green-50',
    trend: selectedLO === 'all' ? '+3% vs last month' : undefined
  }, {
    label: 'Dirty File Count',
    value: data.dirtyFiles.toString(),
    icon: AlertCircleIcon,
    iconColor: 'text-orange-600',
    bgColor: 'bg-orange-50'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6" data-id="element-61">
      {kpis.map(kpi => <div key={kpi.label} className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-62">
          <div className="flex items-start justify-between" data-id="element-63">
            <div className="flex-1" data-id="element-64">
              <p className="text-sm font-medium text-gray-600" data-id="element-65">{kpi.label}</p>
              <p className="text-3xl font-bold text-gray-900 mt-2" data-id="element-66">
                {kpi.value}
              </p>
              {kpi.trend && <p className="text-xs text-gray-500 mt-2" data-id="element-67">{kpi.trend}</p>}
            </div>
            <div className={`${kpi.bgColor} ${kpi.iconColor} p-3 rounded-lg`} data-id="element-68">
              <kpi.icon className="w-6 h-6" data-id="element-69" />
            </div>
          </div>
        </div>)}
    </div>;
}